import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import HomeIndex from '@/components/home/index.vue'
import SeetingAccount from '@/components/setting/account.vue'
import Login from '@/components/login/Login.vue'
import OnlineIndex from '@/components/online/index.vue'
import VideoIndex from '@/components/video/index.vue'

const routes = [
  {
    path: '/',
    redirect: '/home',
    name: 'home',
    component: Home,
    children: [
      { path: 'home', name: 'home-index', component: HomeIndex },
      { path: 'online/index', name: 'online-index', component: OnlineIndex },
      { path: 'video/index', name: 'video-index', component: VideoIndex }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  }
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
